import React, { useEffect, useState } from "react";
import { Col, Form, Row, Image, Table, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { get_vendor_settlement } from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { SINGLE_VENDOR_SETTLEMENT } from "../../../../store/types";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { Modal } from "react-bootstrap";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import moment from "moment";
import SelectFilter from "../../../reusableComponents/selectFilter";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import isEmpty from "../../../../store/validation/is-Empty";
import { Menu, MenuItem } from "@material-ui/core";
import { amApi } from "../../../../api/apiHelper";
import Alert from "react-s-alert";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SAViewPayoutDetailsPopup from "./SAViewPayoutDetailsPopup";
import NoContent from "../../../reusableComponents/NoContentComponent";

const paymentStatus = ["REQUESTED", "APPROVED", "PROCESSED", "REJECTED"];
const settlementStatus = ['IN PROGRESS', 'PARTIAL', 'COMPLETED', 'FAILED'];

const SuperAdminApprovedSettlement = (props) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const history = useHistory();
  const onSuccess = () => {
    setLoading(false);
  };

  const [dateQuery, setDateQuery] = useState({});

  // Filter Data

  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState({
    status: "",
    type: "",
    search: false,
  });

  const userFilter = [
    { title: "Payable Amount", disabled: true, type: 'PA' },
    { title: `Low to High 🠑`, disabled: false, type: 'PA' },
    { title: "High to Low 🠓", disabled: false, type: 'PA' },
    { title: "No of Merchants", disabled: true, type: 'MR' },
    { title: `Low to High 🠑`, disabled: false, type: 'MR' },
    { title: "High to Low 🠓", disabled: false, type: 'MR' },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sort, setSort] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [selected, setSelected] = useState([]);
  const [totalAmount, setTotalAmount] = useState('0.00');

  const [settleData, setSettleData] = useState([]);

  let filteredData = settleData;

  filteredData =
    filteredData &&
    filteredData.filter((item) => {
      return (
        item.id.includes(search.toLowerCase())
      );
    });

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  if (filter.type === 'SS' && filter.status) {
    filteredData = filteredData.filter(ele => filter.status === ele.settlement_status || filter.status === 'IN PROGRESS' ? ele.settlement_status === 'PENDING' : false)
  }
  if (filter.type === 'PA' && filter.status) {
    filteredData = filteredData.filter(ele => filter.status === ele.status)
  }


  if (sort?.type == 'MR') {
    if (sort?.sort === "Low to High 🠑") {
      filteredData = filteredData.sort((a, b) => a.records.length - b.records.length);
    } else if (sort?.sort === "High to Low 🠓") {
      filteredData = filteredData.sort((a, b) => b.records.length - a.records.length);
    }
  } else if (sort?.type == 'PA') {
    if (sort?.sort === "Low to High 🠑") {
      filteredData = filteredData.sort((a, b) => parseFloat(a.total) - parseFloat(b.total));
    } else if (sort?.sort === "High to Low 🠓") {
      filteredData = filteredData.sort((a, b) => parseFloat(b.total) - parseFloat(a.total));
    }
  }

  // const downloadData = {
  //   headers: [
  //     // { label: "Restaurant Name", key: "name" },
  //     // { label: "ID", key: "id" },
  //     // { label: "Tip Amount", key: "tip" },
  //     // { label: "Order Amount", key: "order" },
  //     // { label: "Event Amount", key: "event" },
  //     // { label: "Scan Amount", key: "scan" },
  //     // { label: "Total Amount", key: "total" },
  //   ],
  //   data: filteredData
  //     ? filteredData?.map((ele) => {
  //       return {
  //         // name: ele?.restaurant_name,
  //         // id: ele?._id,
  //         // tip: ele?.orderTipAmount.toFixed(2),
  //         // order: ele?.orderPayAmount.toFixed(2),
  //         // event: ele?.eventPayAmount.toFixed(2),
  //         // scan: ele?.scanAndPayPayAmount.toFixed(2),
  //         // total: (
  //         //   ele?.orderTipAmount +
  //         //   ele?.orderPayAmount +
  //         //   ele?.eventPayAmount +
  //         //   ele?.scanAndPayPayAmount
  //         // ).toFixed(2),
  //       };
  //     })
  //     : [],
  // };

  const [state, setState] = useState(4);
  const [showCancel, setShowCancel] = useState(false);

  const onCancel = () => {
    setShowCancel(true);
  }


  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      async function getData() {
        setLoading(true);
        let data = await amApi.get('/settlement_process', { params: { startDate: dateQuery?.startDate, endDate: dateQuery?.endDate, type: state } });
        setSettleData(data.data);
        setLoading(false);
      }
      getData();
      setTotalAmount(0.00);
      setSelected([]);
    }
  }, [dateQuery, state]);


  const onSelect = (data) => () => {
    if (selected.some(ele => ele._id === data._id)) {
      let newdata = selected.filter(ele => ele._id !== data._id);
      setSelected(newdata);
      let t = data.total;
      setTotalAmount((parseFloat(totalAmount) - t).toFixed(2));
    } else {
      let newdata = [...selected, data];
      setSelected(newdata);
      let t = data.total;
      setTotalAmount((parseFloat(totalAmount) + t).toFixed(2));
    }
  }

  const onSubmit = async (type) => {
    if (selected.length === 0) {
      Alert.error(`<h4>Need to select atleast on record</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      let formData = {
        selectedIds: selected.map(ele => ele._id),
        status: type === 1 ? 'APPROVED' : 'REJECTED'
      }
      let apiUpdate = await amApi.patch('/settlement_process', formData);
      if (apiUpdate.status === 200) {
        if (type === 2) setState(3)
        else setState(2);
        Alert.success(`<h4>${type === 2 ? 'Rejected' : "Approved"} successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  }

  const submitCancel = async (data) => {
    let formData = {
      selectedIds: selected.map(ele => ele._id),
      status: 'REJECTED',
      rejectedType: data.type,
      rejectedReason: data.desc
    }
    let apiUpdate = await amApi.patch('/settlement_process', formData);
    if (apiUpdate.status === 200) {
      setShowCancel(false);
      setState(3)
      Alert.success(`<h4>Rejected successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  }

  const [popup, setPopup] = useState(false)
  const onProcess = () => {
    setPopup(true);
  }

  const [showStatusValue, setShowStatus] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const showStatus = (data) => {
    setStatusData([data])
    setShowStatus(true);
  }


  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-12 pl-5 pr-5">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="super_admin_add_vendor mb-4">
                    <h5 className="main_header_text">
                      Approved Settlement Requests
                    </h5>
                    {/* <div className="f12-400" style={{ color: "#9E9E9E" }}>
                      Please check the data before placing request
                    </div> */}
                  </div>
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400"
                  >
                    Report Run Date: {moment().format("Do MMM, YYYY")}
                  </div>
                  <span
                    className="f12-400 text-grey"
                    style={{ color: "#9E9E9E" }}
                  >
                    Report Range Date:
                  </span>
                  <span className="f12-500">
                    {" "}
                    {moment(dateQuery?.startDate).format('Do MMM, YYYY')} {'-'} {moment(dateQuery?.endDate).format('Do MMM, YYYY')}
                  </span>
                </div>
              </div>
              <Row>
                <Col md={7}>
                  <div className="row super-admin-toptext-searchbar-icon">
                    <div className="col-6">
                      <div className="col-12 p-0">
                        <Form.Control
                          type="text"
                          placeholder="Search By Request Id"
                          onChange={(e) => setSearch(e.target.value)}
                          value={search}
                          className="amSearch w-100"
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  <SelectFilter onDateChange={onDateChangeHandler()} />
                </Col>

                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      className="f10-400"
                      align="center"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                      />
                      <br />
                      Sort
                    </div>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      {userFilter.map((ele, index) => {
                        return (
                          <MenuItem
                            value={ele.title}
                            key={index}
                            onClick={() => setSort({ sort: ele.title, type: ele.type })}
                            disabled={ele.disabled}
                          >
                            {ele.title}
                          </MenuItem>
                        );
                      })}
                    </Menu>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                        alt="Filter Icon"
                        onClick={() => setShowFilter(!showFilter)}
                      />
                      <br />
                      Filter
                    </div>
                    {/* <CSVDownloader
                      filename={"settlement"}
                      headers={{}}
                      data={{}}
                    /> */}
                  </div>
                </div>
                {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <div className="mr-3">
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">
                              Request Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="requestType"
                              value={filter.type}
                              onChange={(e) => setFilter({ ...filter, type: e.target.value })}
                              label="date_range"
                            >
                              {
                                [
                                  { title: "Settlement Status", value: 'SS' },
                                  { title: "Payout Status", value: "PA" }
                                ].map((e) => (
                                  <MenuItem value={e.value}>{e.title}</MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="mr-3">
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">
                              Status
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple"
                              name="status"
                              value={filter.status}
                              onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                              label="date_range"
                            >
                              {filter.type === "SS" &&
                                settlementStatus.map((e) => (
                                  <MenuItem value={e}>
                                    {e}
                                  </MenuItem>
                                ))}
                              {filter.type === "PA" &&
                                paymentStatus.map((e) => (
                                  <MenuItem value={e}>
                                    {e}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            status: "",
                            type: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={() => {
                          setFilter({ ...filter, search: true });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )}
              </Row>
              <div className="mt-3 mb-3 d-flex justify-content-between align-items-center">
                <div>
                  {/* Earnings count */}
                  <div className="d-flex main-component-itemsforsellement align-items-center">
                    <div
                      className="mr-3 p-2"
                      style={{ background: "white", borderRadius: "50%" }}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/earnings.png")}
                        width="45px"
                      />
                    </div>
                    <div>
                      <div className="f18-700">
                        ₹{" "}
                        {totalAmount}
                      </div>
                      <div className="f14-400">Total amount</div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center pt-4 mb-4">
                  {/* {state === 1 && <>
                    <InitiatePayout type={2} selected={selected} onSubmit={onSubmit} onCancel={onCancel} />
                    <InitiatePayout type={1} selected={selected} onSubmit={onSubmit} />
                  </>} */}
                  {state === 4 &&
                    <>
                      <InitiatePayout type={3} selected={selected} onSubmit={onSubmit} onCancel={onCancel} />
                      <InitiatePayout type={4} selected={selected} onSubmit={onSubmit} onProcess={onProcess} />
                    </>}
                  {showCancel && <CancelPayout hideCancel={() => setShowCancel(false)} submitCancel={submitCancel} />}
                </div>
              </div>
              <hr className="mt-0" />
              <div className="mt-2">
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <TableHead />
                    </thead>
                    {loading ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {filteredData?.length ?
                          filteredData.map((data, index) => (
                            <TableBody key={index} data={data} onSelect={onSelect}
                              selected={selected} showStatus={showStatus} />
                          )) : <NoContent />}
                      </>
                    )}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(popup) && <SAViewPayoutDetailsPopup selected={selected} hidePopup={() => setPopup(false)} showStatus={false} />}
      {(showStatusValue) && <SAViewPayoutDetailsPopup selected={statusData} hidePopup={() => setShowStatus(false)} showStatus={true} />}
    </React.Fragment>
  );
};

SuperAdminApprovedSettlement.propTypes = {
  auth: PropTypes.object.isRequired,
  get_vendor_settlement: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_vendor_settlement:
    state.superadminManageTransactions.all_vendor_settlement,
});

export default connect(mapStateToProps, {
  get_vendor_settlement,
})(SuperAdminApprovedSettlement);

const TableHead = (props) => {
  return (
    <tr>
      <th style={{ width: "10%" }}>
        Select <br />
        Items
      </th>
      <th style={{ width: "12%" }}>
        Request <br />
        ID
      </th>
      <th style={{ width: "16%" }}>
        No. Of Requested <br /> Merchants
      </th>
      <th style={{ width: "16%" }}>
        Total Payable <br />
        Amount
      </th>
      {/* <th style={{ width: "10%" }}>
        Events <br /> Amount
      </th> */}
      <th style={{ width: "12%" }}>
        Settlement <br />
        Status
      </th>
      <th style={{ width: "12%" }}>
        Payout <br /> Status
      </th>
      <th style={{ width: "20%" }}>Actions</th>
    </tr>
  );
};

const TableBody = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // const redirect = (data, access) => {
  //   data.startDate = props.startDate;
  //   data.endDate = props.endDate;
  //   dispatch({ type: SINGLE_VENDOR_SETTLEMENT, payload: data });
  //   history.push({
  //     pathname: "/superadminpayoutdetails",
  //     state: { access: access, date: { startDate: props.startDate, endDate: props.endDate } },
  //   });
  // };

  const showStatus = () => {
    props.showStatus(props.data);
  }

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr>
                <td style={{ width: "10%", textAlign: "center" }}>
                  <input type="checkbox" onClick={props.onSelect(props.data)} checked={props.selected.some(ele => ele._id === props.data._id)} disabled={props?.data?.status === 'PROCESSED'} />
                </td>

                <td style={{ width: "12%" }}>#{props?.data?.id}</td>
                <td style={{ width: "16%" }}>{props.data?.records?.length}</td>
                <td style={{ width: "16%" }}>
                  <div className="f12-500">
                    ₹ {props?.data?.total?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="badge badge-warning pointer" onClick={showStatus}>{props?.data?.settlement_status === 'PENDING' ? "IN PROCESS" : props?.data?.settlement_status}</div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="badge badge-success">{props?.data?.status}</div>
                </td>

                <td style={{ width: "20%" }}>
                  <div
                    className="f12-500"
                    style={{ color: "#2196F3", curser: "pointer" }}
                    onClick={() => history.push(`/superadminviewpayoutdetails/${props?.data?._id}`)}
                  >
                    View Merchant <br />
                    Payout Details
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};


const InitiatePayout = (props) => {
  const [state, setState] = useState(false);
  const handleClose = (e) => setState(!state);
  const submit = () => {
    if (props.selected.length) {
      if (props.type === 1) {
        props.onSubmit(props.type);
      }
      if (props.type === 3 || props.type === 2) {
        props.onCancel()
      }
      if (props.type === 4) {
        props.onProcess()
      }
      handleClose()
    } else {
      handleClose()
      Alert.error(`<h4>Need to select atleast on record</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  }
  return (
    <React.Fragment>
      <div
        className={`btn btn-${(props.type === 1 || props.type === 4) ? "danger" : "outline-secondary"
          } btn-md px-5 mr-3`}
        onClick={() => setState(true)}
      >
        {props.type === 1 ? "Approve" : props.type === 2 ? "Reject" : props.type === 3 ? 'Cancel' : props.type === 4 ? 'Process' : ''}
      </div>
      <Modal show={state} onHide={handleClose} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f24-700">
            Request {props.type === 1 ? " Approve" : props.type === 2 ? "Reject" : props.type === 3 ? 'Cancel' : props.type === 4 ? 'Process' : ''}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">
            Are you sure you want to {props.type === 1 ? " approve" : props.type === 2 ? "reject" : props.type === 3 ? 'cancel' : props.type === 4 ? 'process' : ''}{" "}
            this request?
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={handleClose}
                >
                  No
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={submit}
                >
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const CancelPayout = (props) => {
  const types = [{ name: 'Others' }];

  const [type, setType] = useState(types[0].name);

  const [desc, setDesc] = useState('');
  const [descErr, setDescErr] = useState(false);

  const handleDesc = (e) => {
    if (!e.target.value) {
      setDescErr(true);
    } else {
      setDescErr(false);
      setDesc(e.target.value)
    }
  }

  const submitCancel = () => {
    props.submitCancel({ type, desc })
  }

  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hideCancel} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f18-700">
            Reason for Cancellation
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">
            <Form.Group>
              <FormControl
                variant="outlined"
                fullWidth
              >
                <InputLabel htmlFor="outlined-Category">
                  Type
                </InputLabel>
                <Select
                  id="categoryId"
                  value={type}
                  onChange={e => setType(e.target.value)}
                  label="Category"
                  inputProps={{
                    name: "category",
                    id: "outlined-Category",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {types.map((item, index) => (
                    <option label={item.name} value={item.name} key={index}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Form.Group>
            <Form.Group>
              <TextField
                id="description"
                variant="outlined"
                label="Description"
                multiline
                rows="5"
                name="description"
                className={`w-100  ${descErr
                  ? "enError"
                  : ""
                  }`}
                onChange={handleDesc}
                value={desc}
              />
            </Form.Group>
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={props.hideCancel}
                >
                  No
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={submitCancel}
                >
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};